export default __webpack_public_path__ + "static/media/element_7.8e9c07c3.jpg";